import { render, staticRenderFns } from "./LecturerDetail.vue?vue&type=template&id=655b4180&scoped=true&"
import script from "./LecturerDetail.vue?vue&type=script&lang=js&"
export * from "./LecturerDetail.vue?vue&type=script&lang=js&"
import style0 from "./LecturerDetail.vue?vue&type=style&index=0&id=655b4180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b4180",
  null
  
)

export default component.exports